"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _icon = require("@site/pattern-library-utils/icon");
const precheckIcons = Object.freeze({
  UNSELECTED: 'none',
  SELECTED: 'ok-filled',
  CLOSED: 'chevron-down'
});
const getIcon = (isSelected, isOpen = true) => {
  if (!isSelected) {
    return null;
  }
  const iconName = isOpen ? precheckIcons.SELECTED : precheckIcons.CLOSED;
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: iconName
  });
};
exports.getIcon = getIcon;